/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('InAppNotFound', {
  Header: 'Page Not Found',
  Instructions: 'You zigged, we zagged. Or vice versa. Anyway, something has happened that was likely not your fault. We apologize and will look into this so it doesn\'t happen again.'
});